import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import holdingBabyFeetImage from '../images/holding-baby-feet-heart-shape-hands-americord_2023-10-13-001256_hghl_dcd4b851eab0fdc82c7554dc6e8ca81c.jpg';
import istockphotoImage from '../images/istockphoto-2151931552-612x612.jpg';
import logo from '../images/logo_c_only192.png';

function Stat({ k, v }) {
  return (
    <div className="text-center">
      <div className="font-bold text-4xl sm:text-5xl lg:text-6xl bg-gradient-to-r from-primary-600 to-primary-400 bg-clip-text text-transparent">{v}</div>
      <div className="mt-2 text-sm sm:text-base text-muted-foreground font-medium">{k}</div>
    </div>
  );
}

function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section with Banner */}
      <section className="relative overflow-hidden">
        {/* Desktop Layout */}
        <div className="hidden lg:block">
          <div className="absolute inset-0 z-0">
            <div className="absolute inset-0 bg-gradient-to-br from-primary-50 via-blue-50 to-indigo-50"></div>
            <div 
              className="absolute inset-0 opacity-10"
              style={{
                backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%232563eb' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
              }}
            ></div>
          </div>

          <div className="relative z-10 mx-auto max-w-7xl px-6 lg:px-8 pt-20 pb-24 sm:pt-32 sm:pb-32">
            <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
              {/* Left Content */}
              <div className="max-w-2xl animate-fade-in">
                <h1 className="font-bold text-5xl sm:text-6xl lg:text-7xl leading-tight text-foreground tracking-tight">
                  Find the right donor for{' '}
                  <span className="gradient-text">your family</span>
                </h1>
                
                <p className="mt-6 text-lg sm:text-xl text-muted-foreground leading-relaxed text-justify">
                  Connect with verified donors through our transparent, physician-supervised platform. Access detailed profiles, medical histories, and optional video interviews to make the best choice for your family.
                </p>

                <div className="mt-8 flex flex-col sm:flex-row gap-4">
                  <Link
                    to="/donors"
                    className="inline-flex items-center justify-center px-8 py-4 text-base font-semibold text-white bg-gradient-to-r from-primary-600 to-primary-500 rounded-full hover:shadow-xl hover:scale-105 transition-all duration-200 shadow-lg"
                  >
                    Browse Donor Profiles
                    <svg className="ml-2 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </Link>
                  <a
                    href="#how"
                    className="inline-flex items-center justify-center px-8 py-4 text-base font-semibold text-foreground bg-white border-2 border-border rounded-full hover:bg-secondary hover:border-primary-200 transition-all duration-200 shadow-sm"
                  >
                    How It Works
                  </a>
                </div>

                {/* Trust Badges */}
                <div className="mt-12 flex flex-wrap items-center gap-6 text-sm text-muted-foreground">
                  <div className="flex items-center gap-2">
                    <svg className="w-5 h-5 text-primary-600" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    <span className="font-medium">FDA Registered</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <svg className="w-5 h-5 text-primary-600" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    <span className="font-medium">100% Verified</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <svg className="w-5 h-5 text-primary-600" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" />
                    </svg>
                    <span className="font-medium">Personal Support</span>
                  </div>
                </div>
              </div>

              {/* Right Image */}
              <div className="relative lg:h-[600px] animate-slide-up">
                <div className="absolute inset-0 bg-gradient-to-br from-primary-400/20 to-primary-600/20 rounded-3xl blur-3xl"></div>
                <div className="relative h-full rounded-3xl overflow-hidden shadow-2xl">
                  <img 
                    src={holdingBabyFeetImage} 
                    alt="Holding baby feet" 
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
                </div>
                
                {/* Floating Card */}
                <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl shadow-xl p-6 max-w-xs animate-float hidden lg:block">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center">
                      <svg className="w-6 h-6 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <div>
                      <div className="font-semibold text-foreground">Verified donors</div>
                      <div className="text-sm text-muted-foreground">Available now</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile Layout */}
        <div className="lg:hidden">
          {/* Hero Image with Overlay */}
          <div className="relative w-full aspect-square">
            <img 
              src={holdingBabyFeetImage} 
              alt="Holding baby feet" 
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/50 to-black/30"></div>
            
            {/* Content Overlay */}
            <div className="absolute inset-0 flex flex-col items-center justify-center px-6 text-center">
              {/* Logo and Brand */}
              <div className="mb-6">
                <div className="relative inline-block">
                  <div className="absolute inset-0 bg-white/20 blur-2xl rounded-full"></div>
                  <img src={logo} alt="The Open Sperm Bank" className="h-16 w-16 relative z-10 drop-shadow-2xl" />
                </div>
                <div className="mt-3 font-semibold text-lg text-white drop-shadow-lg">
                  The Open Sperm Bank
                </div>
              </div>
              
              {/* Main Heading */}
              <h1 className="font-bold text-4xl sm:text-5xl leading-tight text-white tracking-tight drop-shadow-2xl mb-4">
                Find the right donor for your family
              </h1>
              
              {/* Subtitle */}
              <p className="text-base text-white/95 leading-relaxed max-w-md drop-shadow-lg">
                Connect with verified donors through our transparent, physician-supervised platform. Access detailed profiles, medical histories, and optional video interviews.
              </p>
            </div>
          </div>

          {/* Trust Badges Bar */}
          <div className="bg-gradient-to-r from-primary-600 to-primary-500 px-4 py-4">
            <div className="flex items-center justify-center gap-3 text-white text-xs font-medium flex-wrap">
              <div className="flex items-center gap-1.5">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <span>FDA Compliant</span>
              </div>
              <span className="text-white/60">•</span>
              <div className="flex items-center gap-1.5">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <span>100% Open & Known</span>
              </div>
              <span className="text-white/60">•</span>
              <div className="flex items-center gap-1.5">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.305 2.305 0 01-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582zM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 01-.567.267zM10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v.092a4.535 4.535 0 00-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 10-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 102 0v-.092a4.535 4.535 0 001.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0011 9.092V7.151c.391.127.68.317.843.504a1 1 0 101.511-1.31c-.563-.649-1.413-1.076-2.354-1.253V5z" />
                </svg>
                <span>80% Receive Subsidies</span>
              </div>
              <span className="text-white/60">•</span>
              <div className="flex items-center gap-1.5">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" />
                </svg>
                <span>Personal Support</span>
              </div>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="px-6 py-8 bg-white">
            <div className="flex flex-col gap-3">
              <Link
                to="/donors"
                className="inline-flex items-center justify-center px-8 py-4 text-base font-semibold text-white bg-gradient-to-r from-primary-600 to-primary-500 rounded-full hover:shadow-xl transition-all duration-200 shadow-lg"
              >
                Browse Donor Profiles
                <svg className="ml-2 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </Link>
              <a
                href="#how"
                className="inline-flex items-center justify-center px-8 py-4 text-base font-semibold text-foreground bg-white border-2 border-border rounded-full hover:bg-secondary transition-all duration-200 shadow-sm"
              >
                How It Works
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Bar */}
      <section className="hidden lg:block bg-gradient-to-r from-primary-600 to-primary-500 text-white">
        <div className="mx-auto max-w-7xl px-6 lg:px-8 py-10 lg:py-12">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
            <div className="text-center">
              <div className="font-bold text-3xl sm:text-4xl lg:text-5xl">100%</div>
              <div className="mt-2 text-xs sm:text-sm lg:text-base text-primary-100">Open & Known</div>
            </div>
            <div className="text-center">
              <div className="font-bold text-3xl sm:text-4xl lg:text-5xl">100%</div>
              <div className="mt-2 text-xs sm:text-sm lg:text-base text-primary-100">FDA Compliant</div>
            </div>
            <div className="text-center">
              <div className="font-bold text-3xl sm:text-4xl lg:text-5xl">24/7</div>
              <div className="mt-2 text-xs sm:text-sm lg:text-base text-primary-100">Support Available</div>
            </div>
            <div className="text-center">
              <div className="font-bold text-3xl sm:text-4xl lg:text-5xl">95%</div>
              <div className="mt-2 text-xs sm:text-sm lg:text-base text-primary-100">Satisfaction Rate</div>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section id="how" className="bg-white">
        {/* Desktop Layout */}
        <div className="hidden lg:block py-20 sm:py-28">
          <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <div className="grid lg:grid-cols-2 gap-16 items-start">
              {/* Left Image */}
              <div className="relative order-2 lg:order-1">
                <div className="absolute inset-0 bg-gradient-to-br from-primary-400/20 to-primary-600/20 rounded-3xl blur-3xl"></div>
                <div className="relative rounded-3xl overflow-hidden shadow-2xl mb-6">
                  <img 
                    src={istockphotoImage} 
                    alt="Medical consultation" 
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="inline-flex items-center rounded-full px-4 py-1.5 text-sm font-semibold bg-primary-100 text-primary-700 mb-4">
                  Your Journey to Parenthood
                </div>
                <p className="text-lg text-muted-foreground leading-relaxed text-justify">
                  Access comprehensive donor profiles with medical histories, personality insights, and optional video interviews. We provide the legal framework and medical oversight to protect everyone involved.
                </p>
              </div>

              {/* Right Content */}
              <div className="order-1 lg:order-2">
                <h2 className="font-bold text-4xl sm:text-5xl lg:text-6xl text-foreground tracking-tight mb-12">
                  Know your donor. Get your result.
                </h2>

                <div className="space-y-8">
                  {[
                    { 
                      n: "01", 
                      t: "Browse & Connect", 
                      d: "Search our database of verified donors. View detailed profiles, medical histories, and request video interviews to find the perfect match." 
                    },
                    { 
                      n: "02", 
                      t: "Apply for Subsidy", 
                      d: "Click 'Apply for Subsidy' on any profile. Many donors offer reduced pricing at $1,000–$1,200 to make family building more accessible." 
                    },
                    { 
                      n: "03", 
                      t: "Secure Shipping", 
                      d: "Customized shipping timelines aligned with your cycle. All vials are FDA-compliant and shipped with full medical oversight." 
                    },
                  ].map((s) => (
                    <div key={s.n} className="flex gap-6">
                      <div className="flex-shrink-0">
                        <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-primary-500 to-primary-600 text-white font-bold text-xl flex items-center justify-center shadow-md">
                          {s.n}
                        </div>
                      </div>
                      <div>
                        <h3 className="text-xl font-semibold text-foreground mb-2">{s.t}</h3>
                        <p className="text-muted-foreground leading-relaxed text-justify">{s.d}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile Layout */}
        <div className="lg:hidden">
          {/* Full Width Image with Text Overlay */}
          <div className="relative w-full aspect-square">
            <img 
              src={istockphotoImage} 
              alt="Medical consultation" 
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-black/20"></div>
            
            {/* Text Overlay */}
            <div className="absolute inset-0 flex flex-col items-center justify-center px-6 text-center">
              <h2 className="font-bold text-4xl sm:text-5xl leading-tight text-white tracking-tight mb-4">
                Know your donor. Get your result.
              </h2>
              <p className="text-sm sm:text-base text-white/95 leading-relaxed text-justify max-w-md">
                Access comprehensive donor profiles with medical histories, personality insights, and optional video interviews. We provide the legal framework and medical oversight to protect everyone involved.
              </p>
            </div>
          </div>

          {/* Content Below Image */}
          <div className="px-6 py-12 bg-white">
            <div className="inline-flex items-center rounded-full px-4 py-1.5 text-sm font-semibold bg-primary-100 text-primary-700 mb-6">
              Your Journey to Parenthood
            </div>

            <div className="space-y-6">
              {[
                { 
                  n: "01", 
                  t: "Browse & Connect", 
                  d: "Search our database of verified donors. View detailed profiles, medical histories, and request video interviews to find the perfect match." 
                },
                { 
                  n: "02", 
                  t: "Apply for Subsidy", 
                  d: "Click 'Apply for Subsidy' on any profile. Many donors offer reduced pricing at $1,000–$1,200 to make family building more accessible." 
                },
                { 
                  n: "03", 
                  t: "Secure Shipping", 
                  d: "Customized shipping timelines aligned with your cycle. All vials are FDA-compliant and shipped with full medical oversight." 
                },
              ].map((s) => (
                <div key={s.n} className="flex gap-4">
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-primary-500 to-primary-600 text-white font-bold text-lg flex items-center justify-center shadow-md">
                      {s.n}
                    </div>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-foreground mb-1">{s.t}</h3>
                    <p className="text-sm text-muted-foreground leading-relaxed text-justify">{s.d}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-12 sm:py-16 lg:py-28 bg-secondary">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="font-bold text-3xl sm:text-4xl lg:text-5xl xl:text-6xl text-foreground tracking-tight mb-4">
              A more personal approach to donor selection
            </h2>
            <div className="inline-flex items-center rounded-full px-4 py-1.5 text-sm font-semibold bg-primary-100 text-primary-700 mb-6">
              Why Intended Parents Choose Us
            </div>
            <p className="mt-4 sm:mt-6 text-base sm:text-lg text-muted-foreground leading-relaxed text-justify">
              Unlike traditional sperm banks, we believe in transparency and connection. Our physician-supervised process ensures safety while giving you the information you need.
            </p>
          </div>

          <div className="mt-10 sm:mt-12 lg:mt-16 grid gap-6 sm:gap-8 md:grid-cols-2 lg:grid-cols-3">
            {[
              { 
                icon: (
                  <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                ),
                t: "FDA-Registered Facility", 
                d: "All donations are processed through our physician-supervised, FDA-registered facility meeting the highest safety standards and regulatory requirements." 
              },
              { 
                icon: (
                  <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                  </svg>
                ),
                t: "Transparent Information", 
                d: "Access detailed donor profiles including medical history, genetic screening, education, personality traits, and personal essays to make informed decisions." 
              },
              { 
                icon: (
                  <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                  </svg>
                ),
                t: "Personal Connections", 
                d: "Optional video chat interviews let you get to know your donor personally—a unique feature that sets us apart from traditional sperm banks." 
              },
              { 
                icon: (
                  <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                ),
                t: "Affordable Options", 
                d: "Many donors offer subsidized pricing to help make family building accessible to more intended parents, with options from $1,000–$1,200." 
              },
              { 
                icon: (
                  <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                ),
                t: "Known Donor Support", 
                d: "If you have a known donor, we provide the legal framework and medical oversight to protect everyone involved in the arrangement." 
              },
              { 
                icon: (
                  <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z" />
                  </svg>
                ),
                t: "Dedicated Support", 
                d: "Our care coordinators guide you through every step of the process, from donor selection to shipping and beyond, with personalized attention." 
              },
            ].map((s, i) => (
              <div key={i} className="group relative rounded-2xl sm:rounded-3xl border border-border bg-white p-6 sm:p-8 shadow-soft hover:shadow-large transition-all duration-300 card-hover">
                <div className="flex items-center gap-3 sm:gap-4 mb-3 sm:mb-4">
                  <div className="inline-flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 rounded-xl sm:rounded-2xl bg-gradient-to-br from-primary-500 to-primary-600 text-white shadow-md group-hover:scale-110 transition-transform duration-300 flex-shrink-0">
                    {s.icon}
                  </div>
                  <h3 className="text-lg sm:text-xl font-semibold text-foreground">{s.t}</h3>
                </div>
                <p className="text-sm sm:text-base text-muted-foreground leading-relaxed text-justify">{s.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>



      {/* Testimonials */}
      <section className="py-12 sm:py-16 lg:py-20 bg-gradient-to-br from-primary-50 via-blue-50 to-indigo-50">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="max-w-2xl mx-auto text-center mb-10 sm:mb-12 lg:mb-16">
            <h2 className="font-bold text-3xl sm:text-4xl lg:text-5xl text-foreground tracking-tight mb-4">
              Families we've helped create
            </h2>
            <div className="inline-flex items-center rounded-full px-4 py-1.5 text-sm font-semibold bg-white text-primary-700 shadow-sm">
              Success Stories
            </div>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {[
              {
                quote: "The transparency and personal connection made all the difference. We found the perfect donor and now have a beautiful baby girl.",
                author: "Sarah & Michael",
                location: "San Francisco, CA",
                img: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&q=80"
              },
              {
                quote: "The subsidy program made our dream of parenthood possible. The support team was incredible throughout the entire process.",
                author: "Jennifer",
                location: "Austin, TX",
                img: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop&q=80"
              },
              {
                quote: "Video interviews helped us feel confident in our choice. The medical oversight gave us peace of mind every step of the way.",
                author: "David & Alex",
                location: "Seattle, WA",
                img: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&q=80"
              },
            ].map((testimonial, i) => (
              <div key={i} className="bg-white rounded-2xl sm:rounded-3xl p-6 sm:p-8 shadow-medium hover:shadow-large transition-all duration-300">
                <div className="flex gap-1 mb-3 sm:mb-4">
                  {[...Array(5)].map((_, i) => (
                    <svg key={i} className="w-4 h-4 sm:w-5 sm:h-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                </div>
                <p className="text-sm sm:text-base text-muted-foreground leading-relaxed mb-4 sm:mb-6 italic text-justify">"{testimonial.quote}"</p>
                <div className="flex items-center gap-3 sm:gap-4">
                  <img src={testimonial.img} alt={testimonial.author} className="w-10 h-10 sm:w-12 sm:h-12 rounded-full object-cover" />
                  <div>
                    <div className="font-semibold text-sm sm:text-base text-foreground">{testimonial.author}</div>
                    <div className="text-xs sm:text-sm text-muted-foreground">{testimonial.location}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 sm:py-16 lg:py-28 bg-white">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="relative rounded-2xl sm:rounded-3xl overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-r from-primary-600 to-primary-500"></div>
            <div className="absolute inset-0 opacity-10" style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
            }}></div>
            
            <div className="relative px-6 py-12 sm:px-12 sm:py-16 lg:px-16 lg:py-24 text-center">
              <h2 className="font-bold text-3xl sm:text-4xl lg:text-5xl xl:text-6xl text-white tracking-tight mb-4 sm:mb-6">
                Start your family journey today
              </h2>
              <p className="text-base sm:text-lg lg:text-xl text-primary-100 max-w-2xl mx-auto mb-8 sm:mb-10">
                Browse verified donor profiles, connect through video chats, and explore subsidized options. Our team is here to support you every step of the way.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link 
                  to="/donors" 
                  className="inline-flex items-center justify-center px-8 py-4 text-base font-semibold text-primary-600 bg-white rounded-full hover:bg-gray-50 hover:scale-105 transition-all duration-200 shadow-xl"
                >
                  Browse Donor Profiles
                  <svg className="ml-2 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                  </svg>
                </Link>
                <Link 
                  to="/contact" 
                  className="inline-flex items-center justify-center px-8 py-4 text-base font-semibold text-white border-2 border-white rounded-full hover:bg-white/10 transition-all duration-200"
                >
                  Contact Us
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Home;
